export const PromptPill = defineComponent((_props, ctx) => {
  return () => {
    return (
      <div class="px-3 py-2 bg-primary-100 rounded-full inline-flex text-primary-500 justify-start items-start gap-4 select-none hover:bg-primary-500 hover:text-sky-50 transition-colors cursor-pointer">
        <div class="justify-start text-xs font-semibold font-['Inter'] leading-none">
          {ctx.slots.default ? ctx.slots.default() : ""}
        </div>
      </div>
    );
  };
});
